"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizeType = void 0;
var AuthorizeType;
(function (AuthorizeType) {
    AuthorizeType["ONLINE"] = "online";
    AuthorizeType["DELAYED_ONLINE"] = "delayed_online";
    AuthorizeType["DELAYED_CHARGES"] = "delayed_charges";
})(AuthorizeType = exports.AuthorizeType || (exports.AuthorizeType = {}));
